module.exports = __webpack_public_path__ + "0da5ea54ab0c75286e57f99815fd88cc.fbx";